import { render, staticRenderFns } from "./PackagesIncoming.vue?vue&type=template&id=9c5be674&scoped=true&"
import script from "./PackagesIncoming.vue?vue&type=script&lang=js&"
export * from "./PackagesIncoming.vue?vue&type=script&lang=js&"
import style0 from "./PackagesIncoming.vue?vue&type=style&index=0&id=9c5be674&lang=scss&scoped=true&"
import style1 from "./PackagesIncoming.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5be674",
  null
  
)

export default component.exports